<template>
  <div>
    <!-- 跨组调整配送 -->
    <el-dialog :title="$t('message.crossGroupDeliveryOrderAdjustment')" :close-on-click-modal="false"
      :visible.sync="dialogVisible" width="300px" center>
      <div class="allot">
        <el-select v-model="allotVal" class="item" filterable>
          <el-option v-for="item in allotOptions" :key="item.id" :label="item.realname" :value="item.id">
          </el-option>
        </el-select>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">{{
          $t("message.cancel")
        }}</el-button>
        <el-button type="primary" @click="allotSave">{{
          $t("message.save")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      allotOptions: [],
      dialogVisible: false,
      allotVal: '',
    };
  },
  created() {
    this.$api.getAuthWorkGroupAdminDepart().then(res => {

      this.allotOptions = res.data.p
    })
  },
  methods: {
    // 分配
    allotSave() {
      let datas = {
        porder_sn: [],
      };
      this.$parent.selectList.forEach((item) => {
        datas.porder_sn.push(item.porder_sn);
      });
      datas.p_id = this.allotVal;
      this.$api.porderApi.allotP(datas).then((res) => {
        if (res.code != 0) return this.$message.error(res.msg);
        this.$message.success(res.msg);
        this.dialogVisible = false;
        this.$parent.porderList();
      });
    },
  }
}
</script>
<style lang='scss' scoped>
.allot {
  .el-select {
    width: 100%;
  }
}
</style>